import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const indoorExercisePlayAge1: BlogMetaData = {
  title: '1歳児の運動遊び10選｜室内でできる体を動かす遊び（モンテッソーリ視点）',
  description:
    '1歳児が室内でできる運動遊びを10選紹介。つかまり立ち・伝い歩き・よちよち歩きまで、月齢ごとの発達に合わせた遊び方と、モンテッソーリの「歩く敏感期」を活かした声かけのコツも解説します。',
  thumbnailUrl: '/img/blog-indoor-exercise-play-age-1.webp',
  filePath: buildBlogFilePath('indoor-exercise-play-age-1'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
